import axios, { type HttpResponse } from 'axios';
import type { UserResponse } from './types';
import { biBaseUrl } from '../base';

export const getUser = (): Promise<HttpResponse<UserResponse>> => {
  return axios.get(`${biBaseUrl}/api/user`);
};
export const getUserTokenByTicket = ({
  ticket
}: {
  ticket: string;
}): Promise<
  HttpResponse<{
    token: string;
  }>
> => {
  return axios.get(`${biBaseUrl}/api/verify-ticket`, { params: { ticket } });
};
